import { render, staticRenderFns } from "./loading-overlay.vue?vue&type=template&id=2711c04e&scoped=true&"
import script from "./loading-overlay.vue?vue&type=script&lang=ts&"
export * from "./loading-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./loading-overlay.vue?vue&type=style&index=0&id=2711c04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2711c04e",
  null
  
)

export default component.exports